export const zhTWContent = {
  introduction: {
    content: [
      "自1996年首次亮相以來，寶可夢系列就俘獲了全球玩家的心，成為了全世界最受歡迎的娛樂品牌之一。我們的隨機寶可夢生成器專為各個年齡層的訓練家設計，無論是想要發現新的寶可夢、組建平衡的隊伍，還是想在寶可夢之旅中享受驚喜，都能滿足您的需求。",
      "無論您是在為下一場比賽尋找靈感的資深競技玩家，還是想要擴充圖鑑的休閒玩家，這個寶可夢隨機生成工具都能為您提供一個有趣且互動的方式來探索廣闊的寶可夢世界。"
    ]
  },
  howToUse: {
    content: [
      "使用我們的隨機寶可夢選擇器簡單直觀。按照以下步驟開始生成您的完美寶可夢隊伍：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "選擇寶可夢數量：決定要生成多少隻寶可夢（1-8隻）。" },
          { type: "text", content: "選擇屬性：可以篩選特定的寶可夢屬性，如火屬性、水屬性、電屬性等，也可以選擇\"任意\"來包含所有屬性。" },
          { type: "text", content: "選擇世代：可以選擇從第一世代到第八世代，或選擇\"任意\"來包含所有世代的寶可夢。" },
          { type: "text", content: "設置稀有度：決定生成的寶可夢的稀有程度。" },
          { type: "text", content: "點擊\"生成\"：設置好偏好後，點擊按鈕生成符合條件的寶可夢。" },
          { type: "text", content: "探索結果：查看每隻寶可夢的詳細資訊，包括種族值、特性、屬性等更多資訊！" }
        ]
      },
      "您可以隨時調整參數，多次嘗試以發現不同的寶可夢組合。"
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "完全免費：我們的隨機寶可夢生成器完全免費使用，沒有隱藏費用或訂閱要求。" },
          { type: "text", content: "自定義體驗：可以通過屬性、世代和稀有度來定制您的隨機選擇。" },
          { type: "text", content: "教育工具：了解不同寶可夢的種族值、特性和屬性。" },
          { type: "text", content: "組隊助手：快速生成適合休閒對戰或競技對戰的平衡隊伍。" },
          { type: "text", content: "挑戰創造器：通過限制使用隨機生成的寶可夢來創造獨特的遊戲挑戰。" },
          { type: "text", content: "無需帳號：無需註冊或提供個人資訊，即可立即使用工具。" }
        ]
      }
    ]
  },
  history: {
    content: [
      "寶可夢系列始於1996年，當時田尻智創造了第一款適用於任天堂Game Boy的寶可夢遊戲。受到田尻智童年時期收集昆蟲愛好的啟發，這個概念圍繞著捕捉、訓練和與被稱為\"口袋怪獸\"（Pocket Monsters）或寶可夢的生物對戰展開。",
      "寶可夢歷史上的重要里程碑包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996年：在日本發行原版《寶可夢 紅·綠》" },
          { type: "text", content: "1998年：在國際市場發行《寶可夢 紅·藍》" },
          { type: "text", content: "1999年：在全球推出寶可夢集換式卡牌遊戲" },
          { type: "text", content: "2000年：推出《寶可夢 金·銀》，增加了100隻新寶可夢" },
          { type: "text", content: "2016年：發布《Pokémon GO》，將系列帶入行動平台" },
          { type: "text", content: "2019年：在任天堂Switch平台推出《寶可夢 劍·盾》" }
        ]
      },
      "如今，隨著八個世代超過900隻不同的寶可夢，該系列已擴展到包括電子遊戲、集換式卡牌、動畫系列、電影、周邊商品和行動應用程式，成為了有史以來最高收入的媒體品牌之一。"
    ]
  },
  popularPokemon: {
    content: [
      "在寶可夢的歷史中，一些寶可夢已成為了系列的標誌性象徵：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "皮卡丘：系列的電屬性吉祥物，以其閃電形狀的尾巴和紅潤的臉頰而聞名。" },
          { type: "text", content: "噴火龍：深受粉絲喜愛的火屬性/飛行屬性寶可夢，以其類似龍的外形和強大的能力而著名。" },
          { type: "text", content: "超夢：通過對夢幻的基因操作而創造的傳說中的超能力屬性寶可夢，以其強大的力量而聞名。" },
          { type: "text", content: "伊布：因其獨特的進化能力而備受喜愛，可以進化為水伊布、雷伊布和火伊布等多種形態。" },
          { type: "text", content: "暴鯉龍：從弱小的鯉魚王進化而來的威猛水屬性/飛行屬性寶可夢。" },
          { type: "text", content: "路卡利歐：以其波導之力和在競技對戰中的人氣而聞名的格鬥屬性/鋼屬性寶可夢。" },
          { type: "text", content: "甲賀忍蛙：通過動畫系列而廣受歡迎的水屬性/惡屬性忍者蛙寶可夢。" }
        ]
      },
      "我們的隨機寶可夢生成器讓您有機會發現這些標誌性的寶可夢，以及許多其他同樣引人入勝但較少人知道的物種。"
    ]
  },
  popularGames: {
    content: [
      "寶可夢遊戲系列在多個平台上推出了眾多深受歡迎的作品：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "《寶可夢 紅·藍·黃》：在Game Boy平台上開創系列傳奇的原始遊戲。" },
          { type: "text", content: "《寶可夢 金·銀·水晶》：引入了城都地區和晝夜交替系統。" },
          { type: "text", content: "《寶可夢 紅寶石·藍寶石·綠寶石》：通過豐緣地區和雙打對戰擴展了遊戲世界。" },
          { type: "text", content: "《寶可夢 鑽石·珍珠·白金》：將系列帶入任天堂DS平台，引入線上功能。" },
          { type: "text", content: "《寶可夢 黑·白》：推出全新的寶可夢陣容，著重於故事劇情。" },
          { type: "text", content: "《寶可夢 X·Y》：引入3D模型和超級進化。" },
          { type: "text", content: "《寶可夢 太陽·月亮》：用島嶼試煉重新詮釋道館系統。" },
          { type: "text", content: "《Pokémon GO》：成為全球現象的擴增實境行動遊戲。" },
          { type: "text", content: "《寶可夢 劍·盾》：將系列帶入任天堂Switch平台，引入了曠野地帶概念。" },
          { type: "text", content: "《寶可夢傳說 阿爾宙斯》：系列首次嘗試開放世界玩法。" }
        ]
      },
      "每款遊戲都引入了新的機制和寶可夢，擴展了可以通過我們的隨機寶可夢生成器探索的寶可夢世界。"
    ]
  },
  tradingContests: {
    content: [
      "交換寶可夢自系列誕生以來就是其基本特色。最初的遊戲就是成對發行，專門鼓勵玩家與朋友交換寶可夢來完成圖鑑。這種社交元素幫助傳播了寶可夢的人氣，至今仍然重要。",
      "交換的關鍵特點包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "版本專屬寶可夢，只能通過交換獲得" },
          { type: "text", content: "某些寶可夢如怪力和勇基拉需要通過交換才能進化" },
          { type: "text", content: "現代遊戲中的全球交換系統（GTS）允許全球範圍的交換" },
          { type: "text", content: "作為身份象徵的稀有或閃光寶可夢交換" }
        ]
      },
      "在第三世代引入的寶可夢華麗大賽提供了一種與對戰不同的競爭方式，寶可夢根據外表、表現和魅力而不是戰鬥力來競爭。這些比賽包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "不同的華麗大賽類別（帥氣、美麗、可愛、聰明、強壯）" },
          { type: "text", content: "專門為華麗大賽設計的招式" },
          { type: "text", content: "通過樹果和寶芬管理寶可夢狀態" },
          { type: "text", content: "包含初步視覺評判和表演回合的多階段比賽" }
        ]
      },
      "我們的隨機寶可夢生成器可以幫助您發現在華麗大賽中表現出色或成為有價值的交換夥伴的寶可夢，為您的寶可夢體驗增添新的維度。"
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "這個隨機寶可夢生成器是免費的嗎？",
            answer: "是的，我們的工具完全免費，沒有任何隱藏費用或訂閱要求。"
          },
          {
            type: "faq",
            question: "寶可夢數據的準確性如何？",
            answer: "所有寶可夢數據都來自官方PokéAPI，確保準確性和及時更新。"
          },
          {
            type: "faq",
            question: "我可以生成特定世代的寶可夢嗎？",
            answer: "是的，您可以選擇從第一世代到第八世代的任何世代，或選擇\"任意\"來包含所有世代。"
          },
          {
            type: "faq",
            question: "稀有度篩選器是如何工作的？",
            answer: "我們的算法根據傳說/神話身份、基礎經驗值等因素，為每隻寶可夢分配1-10的稀有度值。"
          },
          {
            type: "faq",
            question: "我可以保存或導出生成的寶可夢嗎？",
            answer: "目前，您可以截圖保存結果。我們正在考慮在未來更新中添加保存/導出功能。"
          },
          {
            type: "faq",
            question: "隨機寶可夢生成器支援行動裝置嗎？",
            answer: "是的，我們的生成器完全支援響應式設計，可以在智慧型手機、平板電腦和桌上型電腦上使用。"
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "我們的隨機寶可夢生成器為休閒玩家和專業訓練師提供了無限可能。無論您是想發現新的最愛、創建主題團隊，還是通過意外組合挑戰自己，我們的工具都提供了一種有趣且具教育意義的方式來探索廣闊的寶可夢世界。",
      "我們不斷努力添加新功能和選項來改進生成器。立即設置您的偏好並點擊「生成」，看看有哪些寶可夢等著您！",
      "與朋友和其他訓練師分享您的結果，告訴我們您如何在寶可夢之旅中使用隨機寶可夢生成器。祝您探索愉快！"
    ]
  },
  // "我像哪個寶可夢？"內容部分
  whichPokemonIntro: {
    content: [
      "您是否曾經想知道自己最像哪個寶可夢？我們的「我像哪個寶可夢？」工具提供了一種有趣且獨特的方式，讓您根據自己的身體特徵發現寶可夢分身。",
      "這個創新功能會分析您的身高和體重，識別出與您體型最接近的寶可夢。無論您是如噴火龍般高大，還是如皮卡丘般緊湊，我們的算法都能以驚人的準確度找到您完美的寶可夢匹配。"
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "使用我們的「我像哪個寶可夢？」工具非常簡單，只需幾秒鐘。請按照以下簡單步驟發現您的寶可夢匹配：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "在提供的表格中輸入您的名字（或暱稱）。" },
          { type: "text", content: "以厘米（cm）輸入您的身高。" },
          { type: "text", content: "以公斤（kg）輸入您的體重。" },
          { type: "text", content: "點擊「尋找我的寶可夢」按鈕查看結果。" },
          { type: "text", content: "查看匹配的寶可夢，包括名稱、類型、體型、重量和相似度分數。" },
          { type: "text", content: "在社交媒體上分享您的結果，或下載為圖片展示給朋友！" }
        ]
      },
      "相似度分數表示您的身體比例與寶可夢的接近程度。百分比越高，匹配度越接近！"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "發現您的寶可夢分身不僅僅是娛樂價值：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "有趣的學習方法：發現並學習與您身體特徵匹配的新寶可夢。" },
          { type: "text", content: "獨特視角：通過寶可夢世界的視角看待自己。" },
          { type: "text", content: "對話起點：與朋友分享結果，比較每個人匹配哪個寶可夢。" },
          { type: "text", content: "角色扮演靈感：為角色扮演找到自然適合您體型的寶可夢。" },
          { type: "text", content: "組建團隊：在寶可夢遊戲中基於您和朋友們的身體相似性創建主題團隊。" }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "匹配算法有多準確？",
            answer: "我們的算法使用來自PokéAPI的官方寶可夢尺寸和重量數據，並基於比例歐幾里得距離計算相似性。雖然它設計更注重趣味性而非科學精確性，但許多用戶發現匹配結果驚人地合適！"
          },
          {
            type: "faq",
            question: "為什麼工具不考慮其他身體特徵？",
            answer: "目前，我們專注於身高和體重是為了簡單起見，也因為這些是所有寶可夢物種中最一致記錄的物理屬性。我們可能會在未來更新中添加更多屬性。"
          },
          {
            type: "faq",
            question: "我可以匹配任何寶可夢嗎？",
            answer: "目前，為了優化性能，工具只匹配原始151隻寶可夢（第一世代）。我們計劃在未來更新中擴展，包括所有世代。"
          },
          {
            type: "faq",
            question: "我的個人數據會被存儲或共享嗎？",
            answer: "不會，我們不存儲您輸入的身高、體重或其他個人信息。所有計算都在您的瀏覽器中進行，不會發送任何內容到我們的服務器。"
          },
          {
            type: "faq",
            question: "為什麼我和有類似測量值的朋友匹配到不同的寶可夢？",
            answer: "身高與體重比例的細微差異可能導致不同的匹配。算法考慮的是比例而非絕對值。"
          },
          {
            type: "faq",
            question: "我可以在社交媒體上分享我的結果嗎？",
            answer: "是的！您可以將結果下載為圖片，或使用提供的按鈕直接分享到Facebook和Twitter等平台。"
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "我們的「我像哪個寶可夢？」工具提供了關於您在奇妙寶可夢世界中可能存在方式的有趣見解。雖然主要設計用於娛樂，但許多用戶發現，除了單純的身體相似性外，他們與匹配寶可夢的性格或能力有著令人驚訝的聯繫。",
      "嘗試稍微調整您的輸入，看看不同的身高和體重如何影響您的匹配，或挑戰朋友和家人找出他們的寶可夢分身。您可能會對產生的寶可夢配對感到驚訝！",
      "無論您是匹配到雄偉的傳說寶可夢、強大的初始寶可夢，還是被低估的小精靈，都要擁抱您的寶可夢分身和您共享的獨特特質。畢竟，在寶可夢世界中，每個物種都有其獨特的優勢和意義。"
    ]
  }
}; 